<div class="mb-12">
  <h2 class="mb-4 text-lg tracking-wider text-primary-500 md:text-xl">
    {{ title.toLocaleUpperCase() }}
  </h2>

  <div
    class="flex flex-col gap-4 sm:items-center sm:justify-around sm:gap-0"
    [ngClass]="this.rowDirectionReverse ? 'sm:flex-row-reverse' : 'sm:flex-row'"
  >
    @if (isTransportDistance) {
      <div class="flex flex-col">
        <p
          class="text-center text-base font-semibold uppercase tracking-wide text-primary-500"
        >
          {{ "impactReport.kgCO2ePerTransport" | transloco }}
        </p>
        <p-chart
          #chartRef
          type="doughnut"
          [data]="data?.chartData"
          [options]="options"
          [plugins]="plugins"
          [style]="{ position: 'relative' }"
        />
      </div>
      <div class="flex flex-col">
        <p
          class="text-center text-base font-semibold uppercase tracking-wide text-primary-500"
        >
          {{ "impactReport.distanceTraveled" | transloco }}
        </p>
        <!-- <p>
          Total:
          {{ totalKilometers() }}
          km
        </p> -->
        <p-chart
          #transportChartRef
          type="pie"
          [data]="transportDistanceData"
          [options]="transportOptions"
          [plugins]="transportPlugins"
          [style]="{ position: 'relative' }"
        />
      </div>
    } @else {
      <p-chart
        #chartRef
        type="doughnut"
        [data]="data?.chartData"
        [options]="options"
        [plugins]="plugins"
        [style]="{ position: 'relative' }"
      />
      <app-legend-graph [data]="data" [isPercentage]="isPercentage" />
    }
  </div>
  @if (isTransportDistance) {
    <app-legend-graph
      [data]="data"
      [isPercentage]="isPercentage"
      [isKilometer]="transportDistanceData"
    />
  }
</div>
